(function() {
  "use strict";

  function initOsmlyUPI() {
    var root = document.getElementById("osmly-upi-generator");
    if (!root || root.dataset.qrpInitialized === "true") return;
    root.dataset.qrpInitialized = "true";

    var upiInput = root.querySelector("#qrp-upi-id");
    var nameInput = root.querySelector("#qrp-payee-name");
    var amountInput = root.querySelector("#qrp-amount");
    var noteInput = root.querySelector("#qrp-note");
    var logoInput = root.querySelector("#qrp-logo-input");
    var logoPreviewBox = root.querySelector("#qrp-logo-preview-box");
    var logoName = root.querySelector("#qrp-logo-name");
    var generateButton = root.querySelector("#qrp-generate");
    var resetButton = root.querySelector("#qrp-reset");
    var previewArea = root.querySelector("#qrp-preview-area");
    var errorBox = root.querySelector("#qrp-error");
    var status = root.querySelector("#qrp-status");
    var paymentInfo = root.querySelector("#qrp-payment-info");
    var actions = root.querySelector("#qrp-actions");
    var downloadButton = root.querySelector("#qrp-download");
    var printButton = root.querySelector("#qrp-print");
    var copyButton = root.querySelector("#qrp-copy");
    var copyMessage = root.querySelector("#qrp-copy-message");
    var displayName = root.querySelector("#qrp-display-name");
    var displayUpi = root.querySelector("#qrp-display-upi");
    var displayAmount = root.querySelector("#qrp-display-amount");
    var displayNote = root.querySelector("#qrp-display-note");
    var amountRow = root.querySelector("#qrp-amount-row");
    var noteRow = root.querySelector("#qrp-note-row");
    var themeOptions = root.querySelectorAll(".qrp-theme-option");

    var currentUPILink = "";
    var currentLogoData = null;
    var selectedTheme = "classic";

    themeOptions.forEach(function(option) {
      option.addEventListener("click", function() {
        themeOptions.forEach(function(item) { item.classList.remove("is-selected"); });
        option.classList.add("is-selected");
        selectedTheme = option.getAttribute("data-theme");
        if (currentUPILink) generateQR();
      });
    });

    function safeText(value) {
      return String(value || "").trim();
    }

    logoInput.addEventListener("change", function() {
      errorBox.textContent = "";
      var file = logoInput.files && logoInput.files[0];
      if (!file) return;

      if (file.size > 2 * 1024 * 1024) {
        errorBox.textContent = "Logo must be smaller than 2MB.";
        logoInput.value = "";
        return;
      }

      var allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/svg+xml"];
      if (allowedTypes.indexOf(file.type) === -1) {
        errorBox.textContent = "Please upload a PNG, JPG or SVG logo.";
        logoInput.value = "";
        return;
      }

      var reader = new FileReader();
      reader.onload = function(event) {
        currentLogoData = event.target.result;
        logoPreviewBox.innerHTML = "";
        var img = document.createElement("img");
        img.src = currentLogoData;
        img.alt = "Your logo";
        logoPreviewBox.appendChild(img);
        logoName.textContent = file.name;
        if (currentUPILink) generateQR();
      };
      reader.onerror = function() {
        errorBox.textContent = "Unable to read the logo file.";
      };
      reader.readAsDataURL(file);
    });

    function buildUPILink() {
      var upi = safeText(upiInput.value);
      var name = safeText(nameInput.value);
      var amount = safeText(amountInput.value);
      var note = safeText(noteInput.value);

      if (!upi) throw new Error("Please enter your UPI ID.");
      if (!name) throw new Error("Please enter the business or payee name.");

      var upiPattern = /^[A-Za-z0-9._-]{2,256}@[A-Za-z0-9.-]{2,64}$/;
      if (!upiPattern.test(upi)) {
        throw new Error("Please enter a valid UPI ID, for example business@upi.");
      }

      if (amount) {
        var numericAmount = Number(amount);
        if (!Number.isFinite(numericAmount) || numericAmount <= 0) {
          throw new Error("Please enter a valid amount.");
        }
      }

      var params = new URLSearchParams();
      params.set("pa", upi);
      params.set("pn", name);
      params.set("cu", "INR");
      if (amount) params.set("am", Number(amount).toFixed(2));
      if (note) params.set("tn", note);

      return "upi://pay?" + params.toString();
    }

    function roundRect(ctx, x, y, width, height, radius) {
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
    }

    function drawCenterLogo(ctx, logo, centerX, centerY) {
      ctx.save();
      ctx.beginPath();
      ctx.arc(centerX, centerY, 82, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();
      ctx.lineWidth = 8;
      ctx.strokeStyle = "#102f72";
      ctx.stroke();

      ctx.beginPath();
      ctx.arc(centerX, centerY, 65, 0, Math.PI * 2);
      ctx.clip();

      if (logo) {
        var maxSize = 115;
        var scale = Math.min(maxSize / logo.width, maxSize / logo.height);
        var width = logo.width * scale;
        var height = logo.height * scale;
        ctx.drawImage(logo, centerX - width / 2, centerY - height / 2, width, height);
      } else {
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "900 36px Arial";
        ctx.fillStyle = "#1558d6";
        ctx.fillText("OSM", centerX - 16, centerY + 3);
        ctx.fillStyle = "#17233c";
        ctx.fillText("LY", centerX + 26, centerY + 3);

        ctx.strokeStyle = "#1558d6";
        ctx.lineWidth = 6;
        ctx.beginPath();
        ctx.arc(centerX, centerY + 10, 44, 0.25, Math.PI - 0.25);
        ctx.stroke();
      }
      ctx.restore();
    }

    function loadLogoImage(data) {
      return new Promise(function(resolve) {
        if (!data) return resolve(null);
        var img = new Image();
        img.onload = function() { resolve(img); };
        img.onerror = function() { resolve(null); };
        img.src = data;
      });
    }

    function drawAppIcon(ctx, x, y, type) {
      ctx.save();
      if (type === "gpay") {
        ctx.beginPath();
        ctx.arc(x, y, 30, 0, Math.PI * 2);
        ctx.fillStyle = "#ffffff";
        ctx.fill();

        ctx.fillStyle = "#4285f4";
        ctx.beginPath();
        ctx.arc(x - 12, y - 5, 14, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = "#34a853";
        ctx.beginPath();
        ctx.arc(x + 8, y + 9, 14, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = "#fbbc05";
        ctx.beginPath();
        ctx.arc(x - 1, y - 8, 13, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = "#ea4335";
        ctx.beginPath();
        ctx.arc(x + 12, y - 7, 12, 0, Math.PI * 2);
        ctx.fill();
      } else if (type === "phonepe") {
        ctx.beginPath();
        ctx.arc(x, y, 30, 0, Math.PI * 2);
        ctx.fillStyle = "#5f259f";
        ctx.fill();
        ctx.fillStyle = "#ffffff";
        ctx.font = "900 34px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("पे", x, y + 2);
      } else if (type === "paytm") {
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = "900 32px Arial";
        ctx.fillStyle = "#172f69";
        ctx.fillText("pay", x - 13, y);
        ctx.fillStyle = "#00a9e8";
        ctx.fillText("tm", x + 31, y);
      } else if (type === "bhim") {
        ctx.fillStyle = "#ff9800";
        ctx.beginPath();
        ctx.moveTo(x - 17, y + 28);
        ctx.lineTo(x + 13, y - 28);
        ctx.lineTo(x + 27, y + 1);
        ctx.closePath();
        ctx.fill();

        ctx.fillStyle = "#00a65a";
        ctx.beginPath();
        ctx.moveTo(x + 13, y - 28);
        ctx.lineTo(x + 30, y + 0);
        ctx.lineTo(x + 12, y + 18);
        ctx.closePath();
        ctx.fill();
      } else {
        ctx.beginPath();
        ctx.arc(x, y, 30, 0, Math.PI * 2);
        ctx.fillStyle = "#17212d";
        ctx.fill();
        ctx.fillStyle = "#ffffff";
        ctx.font = "700 23px Arial";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.fillText("pay", x, y - 2);

        ctx.strokeStyle = "#ffb000";
        ctx.lineWidth = 3;
        ctx.beginPath();
        ctx.arc(x, y + 5, 17, 0.2, Math.PI - 0.2);
        ctx.stroke();
      }
      ctx.restore();
    }

    function drawUPILogo(ctx) {
      ctx.save();
      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.font = "900 68px Arial";
      ctx.fillStyle = "#4b4b4b";
      ctx.fillText("UPI", 830, 105);

      ctx.fillStyle = "#ff9800";
      ctx.beginPath();
      ctx.moveTo(1100, 65);
      ctx.lineTo(1128, 105);
      ctx.lineTo(1100, 145);
      ctx.lineTo(1110, 105);
      ctx.closePath();
      ctx.fill();

      ctx.fillStyle = "#009b52";
      ctx.beginPath();
      ctx.moveTo(1125, 75);
      ctx.lineTo(1150, 110);
      ctx.lineTo(1127, 135);
      ctx.lineTo(1137, 108);
      ctx.closePath();
      ctx.fill();

      ctx.font = "500 22px Arial";
      ctx.fillStyle = "#555555";
      ctx.fillText("UNIFIED PAYMENTS INTERFACE", 835, 148);
      ctx.restore();
    }

    async function createAlternatePoster(qrCanvas, themeKey) {
      var poster = document.createElement("canvas");
      poster.id = "qrp-poster-canvas";
      poster.width = 1200;
      poster.height = 1800;

      var ctx = poster.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      var themes = {
        elegant: { bg: "#f7f3ea", paper: "#fffdf8", primary: "#171717", secondary: "#8f6d18", accent: "#c9a227", text: "#171717", muted: "#756f63", panel: "#efe8d8", border: "#c9a227" },
        festive: { bg: "#fff8ef", paper: "#ffffff", primary: "#d83b12", secondary: "#f4511e", accent: "#ffb300", text: "#4a2416", muted: "#8b6b5d", panel: "#fff0dc", border: "#f4511e" },
        fresh: { bg: "#f2fff9", paper: "#ffffff", primary: "#087f5b", secondary: "#0b9b72", accent: "#8bc34a", text: "#12352a", muted: "#66857a", panel: "#e5f8ef", border: "#087f5b" },
        royal: { bg: "#faf5ff", paper: "#ffffff", primary: "#5b21b6", secondary: "#7c3aed", accent: "#c084fc", text: "#28113f", muted: "#77638a", panel: "#f1e8ff", border: "#7c3aed" },
        minimal: { bg: "#ffffff", paper: "#ffffff", primary: "#b91c1c", secondary: "#dc2626", accent: "#111827", text: "#111827", muted: "#6b7280", panel: "#f5f5f5", border: "#b91c1c" }
      };

      var t = themes[themeKey] || themes.elegant;

      function fitText(text, maxWidth, startSize, minSize, weight, family) {
        text = safeText(text);
        var size = startSize;
        family = family || "Arial";
        while (size > minSize) {
          ctx.font = weight + " " + size + "px " + family;
          if (ctx.measureText(text).width <= maxWidth) return size;
          size -= 2;
        }
        return minSize;
      }

      function drawFitted(text, x, y, maxWidth, startSize, minSize, weight, color, align, family) {
        text = safeText(text);
        if (!text) return;
        var size = fitText(text, maxWidth, startSize, minSize, weight, family);
        ctx.font = weight + " " + size + "px " + (family || "Arial");
        ctx.fillStyle = color;
        ctx.textAlign = align || "center";
        ctx.textBaseline = "middle";
        ctx.fillText(text, x, y);
      }

      function wrapLines(text, maxWidth, fontSize, weight, family, maxLines) {
        text = safeText(text);
        if (!text) return [];
        ctx.font = weight + " " + fontSize + "px " + (family || "Arial");
        var words = text.split(/\s+/);
        var lines = [];
        var line = "";

        words.forEach(function(word) {
          var test = line ? line + " " + word : word;
          if (ctx.measureText(test).width <= maxWidth) {
            line = test;
          } else {
            if (line) lines.push(line);
            line = word;
          }
        });
        if (line) lines.push(line);

        if (maxLines && lines.length > maxLines) {
          lines = lines.slice(0, maxLines);
          var last = lines[maxLines - 1];
          while (ctx.measureText(last + "…").width > maxWidth && last.length > 1) {
            last = last.slice(0, -1);
          }
          lines[maxLines - 1] = last + "…";
        }
        return lines;
      }

      function drawWrapped(text, x, firstY, maxWidth, fontSize, lineHeight, weight, color, align, maxLines, family) {
        var lines = wrapLines(text, maxWidth, fontSize, weight, family, maxLines);
        ctx.font = weight + " " + fontSize + "px " + (family || "Arial");
        ctx.fillStyle = color;
        ctx.textAlign = align || "center";
        ctx.textBaseline = "middle";
        lines.forEach(function(line, index) {
          ctx.fillText(line, x, firstY + index * lineHeight);
        });
      }

      ctx.fillStyle = t.bg;
      ctx.fillRect(0, 0, 1200, 1800);

      ctx.fillStyle = t.paper;
      roundRect(ctx, 30, 30, 1140, 1740, 36);
      ctx.fill();

      ctx.strokeStyle = t.border;
      ctx.lineWidth = 8;
      roundRect(ctx, 30, 30, 1140, 1740, 36);
      ctx.stroke();

      ctx.save();
      if (themeKey === "elegant") {
        ctx.fillStyle = t.primary;
        roundRect(ctx, 30, 30, 1140, 235, 36);
        ctx.fill();
        ctx.fillStyle = t.accent;
        ctx.fillRect(30, 235, 1140, 8);
      } else if (themeKey === "festive") {
        ctx.fillStyle = t.primary;
        ctx.beginPath();
        ctx.moveTo(30, 30);
        ctx.lineTo(1170, 30);
        ctx.lineTo(1170, 255);
        ctx.bezierCurveTo(920, 170, 660, 330, 380, 210);
        ctx.bezierCurveTo(230, 145, 110, 180, 30, 275);
        ctx.closePath();
        ctx.fill();
        ctx.strokeStyle = t.accent;
        ctx.lineWidth = 20;
        ctx.lineCap = "round";
        ctx.beginPath();
        ctx.moveTo(40, 280);
        ctx.bezierCurveTo(280, 120, 500, 280, 700, 170);
        ctx.stroke();
      } else if (themeKey === "fresh") {
        ctx.fillStyle = t.primary;
        ctx.beginPath();
        ctx.moveTo(30, 30);
        ctx.lineTo(1170, 30);
        ctx.lineTo(1170, 215);
        ctx.bezierCurveTo(900, 300, 700, 140, 450, 220);
        ctx.bezierCurveTo(270, 280, 150, 230, 30, 330);
        ctx.closePath();
        ctx.fill();
        ctx.fillStyle = t.accent;
        ctx.beginPath();
        ctx.arc(1060, 135, 62, 0, Math.PI * 2);
        ctx.fill();
      } else if (themeKey === "royal") {
        var gradient = ctx.createLinearGradient(30, 30, 1170, 270);
        gradient.addColorStop(0, t.primary);
        gradient.addColorStop(1, t.secondary);
        ctx.fillStyle = gradient;
        roundRect(ctx, 30, 30, 1140, 260, 36);
        ctx.fill();
        ctx.strokeStyle = t.accent;
        ctx.lineWidth = 7;
        roundRect(ctx, 55, 55, 1090, 210, 24);
        ctx.stroke();
      } else {
        ctx.fillStyle = t.primary;
        ctx.fillRect(30, 30, 1140, 15);
        ctx.fillStyle = t.accent;
        ctx.fillRect(30, 45, 260, 8);
      }
      ctx.restore();

      var headerWhite = themeKey === "elegant" || themeKey === "royal";
      drawFitted("SCAN & PAY", 600, themeKey === "minimal" ? 145 : 150, 800, 78, 54, "900", headerWhite ? "#ffffff" : t.primary);
      drawFitted("with any UPI App", 600, themeKey === "minimal" ? 205 : 220, 700, 31, 22, "600", headerWhite ? "#ffffff" : t.text);

      if (!headerWhite) {
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        ctx.font = "900 42px Arial";
        ctx.fillStyle = t.primary;
        ctx.fillText("UPI", 85, 105);
      }

      var appData = [
        {name: "GPay", type: "gpay", x: 210},
        {name: "PhonePe", type: "phonepe", x: 405},
        {name: "Paytm", type: "paytm", x: 600},
        {name: "BHIM", type: "bhim", x: 795},
        {name: "Amazon Pay", type: "amazon", x: 990}
      ];

      var appY = (themeKey === "elegant" || themeKey === "royal") ? 355 : 380;
      ctx.strokeStyle = t.border;
      ctx.globalAlpha = 0.35;
      ctx.lineWidth = 2;

      [307, 502, 697, 892].forEach(function(x) {
        ctx.beginPath();
        ctx.moveTo(x, appY - 48);
        ctx.lineTo(x, appY + 62);
        ctx.stroke();
      });
      ctx.globalAlpha = 1;

      appData.forEach(function(app) {
        drawAppIcon(ctx, app.x, appY, app.type);
        drawFitted(app.name, app.x, appY + 62, 170, 23, 16, "700", t.text);
      });

      var qrSize = 610;
      var qrX = (1200 - qrSize) / 2;
      var qrY = 535;

      ctx.fillStyle = "#ffffff";
      roundRect(ctx, qrX - 30, qrY - 30, qrSize + 60, qrSize + 60, 30);
      ctx.fill();

      ctx.strokeStyle = t.primary;
      ctx.lineWidth = 7;
      roundRect(ctx, qrX - 30, qrY - 30, qrSize + 60, qrSize + 60, 30);
      ctx.stroke();

      ctx.strokeStyle = t.accent;
      ctx.lineWidth = 12;
      ctx.lineCap = "round";
      var c = 78;

      [
        [qrX - 45, qrY - 45, qrX + c, qrY - 45],
        [qrX - 45, qrY - 45, qrX - 45, qrY + c],
        [qrX + qrSize - c, qrY + qrSize + 45, qrX + qrSize + 45, qrY + qrSize + 45],
        [qrX + qrSize + 45, qrY + qrSize - c, qrX + qrSize + 45, qrY + qrSize + 45]
      ].forEach(function(line) {
        ctx.beginPath();
        ctx.moveTo(line[0], line[1]);
        ctx.lineTo(line[2], line[3]);
        ctx.stroke();
      });

      ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
      var logoImage = await loadLogoImage(currentLogoData);
      drawCenterLogo(ctx, logoImage, qrX + qrSize / 2, qrY + qrSize / 2);

      var payY = qrY + qrSize + 65;
      drawFitted("PAY DIRECTLY", 600, payY, 650, 42, 30, "900", t.primary);
      drawFitted("Scan the QR code using any UPI app", 600, payY + 40, 850, 23, 17, "600", t.muted);

      var infoY = payY + 68;
      var panelX = 110;
      var panelW = 980;
      var panelH = 225;

      ctx.fillStyle = t.panel;
      roundRect(ctx, panelX, infoY, panelW, panelH, 24);
      ctx.fill();

      ctx.strokeStyle = t.border;
      ctx.globalAlpha = 0.28;
      ctx.lineWidth = 2;
      roundRect(ctx, panelX, infoY, panelW, panelH, 24);
      ctx.stroke();
      ctx.globalAlpha = 1;

      ctx.textAlign = "left";
      ctx.textBaseline = "middle";
      ctx.font = "700 18px Arial";
      ctx.fillStyle = t.muted;
      ctx.fillText("PAYEE", panelX + 35, infoY + 34);

      var payee = safeText(nameInput.value);
      drawFitted(payee || "Business", panelX + 35, infoY + 73, 545, 27, 17, "800", t.text, "left");

      ctx.font = "700 18px Arial";
      ctx.fillStyle = t.muted;
      ctx.textAlign = "right";
      ctx.fillText("UPI ID", panelX + panelW - 35, infoY + 34);
      drawFitted(safeText(upiInput.value), panelX + panelW - 35, infoY + 72, 400, 23, 14, "700", t.primary, "right");

      var amount = safeText(amountInput.value);
      if (amount) {
        ctx.font = "700 18px Arial";
        ctx.fillStyle = t.muted;
        ctx.textAlign = "right";
        ctx.fillText("AMOUNT", panelX + panelW - 35, infoY + 112);
        drawFitted("₹" + Number(amount).toFixed(2), panelX + panelW - 35, infoY + 146, 300, 27, 18, "900", t.text, "right");
      }

      var note = safeText(noteInput.value);
      if (note) {
        ctx.font = "700 18px Arial";
        ctx.fillStyle = t.muted;
        ctx.textAlign = "left";
        ctx.fillText("NOTE", panelX + 35, infoY + 123);
        drawWrapped(note, panelX + 35, infoY + 157, 545, 21, 28, "600", t.text, "left", 2);
      }

      var footerY = 1640;
      ctx.fillStyle = t.primary;
      roundRect(ctx, 245, footerY, 710, 72, 36);
      ctx.fill();

      drawFitted("Powered by : Osmly.in", 600, footerY + 36, 620, 22, 16, "800", "#ffffff");
      drawFitted("— Thank You —", 600, 1745, 500, 28, 20, "italic", t.primary, "center", "cursive");

      return poster;
    }

    async function createPoster(qrCanvas, themeKey) {
      if (themeKey && themeKey !== "classic") {
        return await createAlternatePoster(qrCanvas, themeKey);
      }

      var poster = document.createElement("canvas");
      poster.id = "qrp-poster-canvas";
      poster.width = 1200;
      poster.height = 1800;

      var ctx = poster.getContext("2d");
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, 1200, 1800);

      ctx.lineWidth = 8;
      ctx.strokeStyle = "#1558d6";
      roundRect(ctx, 20, 20, 1160, 1760, 40);
      ctx.stroke();

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(20, 20);
      ctx.lineTo(430, 20);
      ctx.bezierCurveTo(220, 155, 75, 245, 20, 375);
      ctx.closePath();
      ctx.fillStyle = "#1558d6";
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(20, 280);
      ctx.bezierCurveTo(110, 175, 245, 85, 395, 20);
      ctx.lineWidth = 23;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#ff9800";
      ctx.stroke();
      ctx.restore();

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(1180, 1390);
      ctx.bezierCurveTo(1090, 1540, 960, 1680, 760, 1780);
      ctx.lineTo(1180, 1780);
      ctx.closePath();
      ctx.fillStyle = "#1558d6";
      ctx.fill();

      ctx.beginPath();
      ctx.moveTo(1180, 1500);
      ctx.bezierCurveTo(1090, 1630, 980, 1720, 850, 1780);
      ctx.lineWidth = 23;
      ctx.strokeStyle = "#ff9800";
      ctx.stroke();
      ctx.restore();

      drawUPILogo(ctx);

      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.font = "900 88px Arial";
      ctx.fillStyle = "#12367c";
      ctx.fillText("Scan & Pay", 600, 270);

      ctx.font = "600 46px Arial";
      ctx.fillStyle = "#15213b";
      ctx.fillText("with any UPI App", 600, 340);

      ctx.lineCap = "round";
      ctx.lineWidth = 9;
      ctx.strokeStyle = "#ff9800";
      ctx.beginPath(); ctx.moveTo(245, 230); ctx.lineTo(215, 205); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(245, 285); ctx.lineTo(215, 310); ctx.stroke();
      ctx.strokeStyle = "#1558d6";
      ctx.beginPath(); ctx.moveTo(245, 255); ctx.lineTo(205, 255); ctx.stroke();
      ctx.strokeStyle = "#ff9800";
      ctx.beginPath(); ctx.moveTo(955, 230); ctx.lineTo(985, 205); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(955, 285); ctx.lineTo(985, 310); ctx.stroke();
      ctx.strokeStyle = "#1558d6";
      ctx.beginPath(); ctx.moveTo(955, 255); ctx.lineTo(995, 255); ctx.stroke();

      var appData = [
        { name: "GPay", type: "gpay", x: 210 },
        { name: "PhonePe", type: "phonepe", x: 405 },
        { name: "Paytm", type: "paytm", x: 600 },
        { name: "BHIM", type: "bhim", x: 795 },
        { name: "Amazon Pay", type: "amazon", x: 990 }
      ];

      ctx.strokeStyle = "#bcd7fa";
      ctx.lineWidth = 2;
      [307, 502, 697, 892].forEach(function(x) {
        ctx.beginPath();
        ctx.moveTo(x, 400);
        ctx.lineTo(x, 505);
        ctx.stroke();
      });

      appData.forEach(function(app) {
        drawAppIcon(ctx, app.x, 430, app.type);
        ctx.textAlign = "center";
        ctx.font = "700 26px Arial";
        ctx.fillStyle = "#18243c";
        ctx.fillText(app.name, app.x, 490);
      });

      var qrSize = 690;
      var qrX = (1200 - qrSize) / 2;
      var qrY = 570;

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(qrX - 10, qrY - 10, qrSize + 20, qrSize + 20);

      ctx.strokeStyle = "#1558d6";
      ctx.lineWidth = 10;
      ctx.lineCap = "round";

      ctx.beginPath(); ctx.moveTo(qrX - 25, qrY + 100); ctx.lineTo(qrX - 25, qrY - 20); ctx.lineTo(qrX + 100, qrY - 20); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(qrX + qrSize - 100, qrY - 20); ctx.lineTo(qrX + qrSize + 25, qrY - 20); ctx.lineTo(qrX + qrSize + 25, qrY + 100); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(qrX - 25, qrY + qrSize - 100); ctx.lineTo(qrX - 25, qrY + qrSize + 20); ctx.lineTo(qrX + 100, qrY + qrSize + 20); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(qrX + qrSize - 100, qrY + qrSize + 20); ctx.lineTo(qrX + qrSize + 25, qrY + qrSize + 20); ctx.lineTo(qrX + qrSize + 25, qrY + qrSize - 100); ctx.stroke();

      ctx.drawImage(qrCanvas, qrX, qrY, qrSize, qrSize);
      var logoImage = await loadLogoImage(currentLogoData);
      drawCenterLogo(ctx, logoImage, qrX + qrSize / 2, qrY + qrSize / 2);

      var textY = qrY + qrSize + 105;
      ctx.textAlign = "center";
      ctx.font = "900 46px Arial";
      ctx.fillStyle = "#12367c";
      ctx.fillText("Pay directly to", 600, textY);
      ctx.fillText("our UPI ID", 600, textY + 55);

      ctx.font = "800 22px Arial";
      ctx.fillStyle = "#12367c";
      ctx.fillText("F A S T      •      S E C U R E      •      E A S Y", 600, textY + 112);

      var infoY = textY + 160;
      ctx.fillStyle = "#eef6ff";
      roundRect(ctx, 175, infoY, 850, 95, 20);
      ctx.fill();

      ctx.textAlign = "left";
      ctx.font = "600 21px Arial";
      ctx.fillStyle = "#64748b";
      ctx.fillText("Payee", 215, infoY + 34);

      ctx.font = "800 24px Arial";
      ctx.fillStyle = "#102044";
      ctx.fillText(safeText(nameInput.value).substring(0, 34), 215, infoY + 68);

      ctx.textAlign = "right";
      ctx.font = "700 22px Arial";
      ctx.fillStyle = "#1558d6";
      ctx.fillText(safeText(upiInput.value).substring(0, 34), 985, infoY + 53);

      var amount = safeText(amountInput.value);
      if (amount) {
        ctx.textAlign = "center";
        ctx.font = "900 27px Arial";
        ctx.fillStyle = "#102044";
        ctx.fillText("Amount: ₹" + Number(amount).toFixed(2), 600, infoY + 128);
      }

      var poweredY = 1625;
      ctx.fillStyle = "#dcecff";
      roundRect(ctx, 300, poweredY, 600, 68, 34);
      ctx.fill();

      ctx.textAlign = "center";
      ctx.font = "900 25px Arial";
      ctx.fillStyle = "#1558d6";
      ctx.fillText("♥", 345, poweredY + 35);

      ctx.strokeStyle = "#9dbce5";
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(380, poweredY + 15);
      ctx.lineTo(380, poweredY + 53);
      ctx.stroke();

      ctx.font = "700 25px Arial";
      ctx.fillStyle = "#12367c";
      ctx.fillText("Powered by : Osmly.in", 640, poweredY + 36);

      ctx.textAlign = "left";
      ctx.font = "italic 31px cursive";
      ctx.fillStyle = "#12367c";
      ctx.fillText("— Thank You —", 82, 1735);

      return poster;
    }

    async function generateQR() {
      errorBox.textContent = "";
      copyMessage.textContent = "";

      try {
        currentUPILink = buildUPILink();
      } catch(error) {
        errorBox.textContent = error.message;
        return;
      }

      if (typeof QRCode === "undefined") {
        errorBox.textContent = "QR generator library is loading. Please try again.";
        return;
      }

      var temporaryQR = document.createElement("div");
      temporaryQR.style.position = "fixed";
      temporaryQR.style.left = "-99999px";
      temporaryQR.style.top = "0";
      temporaryQR.style.width = "1000px";
      temporaryQR.style.height = "1000px";
      document.body.appendChild(temporaryQR);

      new QRCode(temporaryQR, {
        text: currentUPILink,
        width: 1000,
        height: 1000,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });

      setTimeout(async function() {
        var qrCanvas = temporaryQR.querySelector("canvas");
        if (!qrCanvas) {
          var qrImage = temporaryQR.querySelector("img");
          if (!qrImage) {
            errorBox.textContent = "Unable to generate QR. Please try again.";
            temporaryQR.remove();
            return;
          }
          qrCanvas = document.createElement("canvas");
          qrCanvas.width = 1000;
          qrCanvas.height = 1000;
          var qrContext = qrCanvas.getContext("2d");
          await new Promise(function(resolve) {
            if (qrImage.complete) resolve();
            else { qrImage.onload = resolve; qrImage.onerror = resolve; }
          });
          qrContext.drawImage(qrImage, 0, 0, 1000, 1000);
        }

        var poster = await createPoster(qrCanvas, selectedTheme);
        previewArea.innerHTML = "";
        previewArea.appendChild(poster);

        displayName.textContent = safeText(nameInput.value);
        displayUpi.textContent = safeText(upiInput.value);

        var amount = safeText(amountInput.value);
        if (amount) {
          displayAmount.textContent = "₹" + Number(amount).toFixed(2);
          amountRow.style.display = "flex";
        } else {
          amountRow.style.display = "none";
        }

        var note = safeText(noteInput.value);
        if (note) {
          displayNote.textContent = note;
          noteRow.style.display = "flex";
        } else {
          noteRow.style.display = "none";
        }

        paymentInfo.style.display = "block";
        actions.style.display = "grid";
        status.textContent = "QR Generated";
        status.style.background = "#dcfce7";
        status.style.color = "#15803d";
        temporaryQR.remove();

        if (window.innerWidth <= 900) {
          setTimeout(function() {
            previewArea.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 150);
        }
      }, 150);
    }

    function downloadQR() {
      var poster = root.querySelector("#qrp-poster-canvas");
      if (!poster) {
        errorBox.textContent = "Please generate your QR first.";
        return;
      }
      var dataURL = poster.toDataURL("image/png");
      var link = document.createElement("a");
      var businessName = safeText(nameInput.value).replace(/[^a-z0-9]+/gi, "-").replace(/^-+|-+$/g, "");
      if (!businessName) businessName = "osmly";

      link.download = businessName + "-osmly-upi-qr-4x6.png";
      link.href = dataURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    function copyUPILink() {
      if (!currentUPILink) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(currentUPILink).then(function() {
          showCopyMessage("UPI payment link copied!");
        }).catch(function() {
          fallbackCopy();
        });
      } else {
        fallbackCopy();
      }
    }

    function fallbackCopy() {
      var textarea = document.createElement("textarea");
      textarea.value = currentUPILink;
      textarea.style.position = "fixed";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      try {
        document.execCommand("copy");
        showCopyMessage("UPI payment link copied!");
      } catch(error) {
        showCopyMessage("Unable to copy the link.");
      }
      document.body.removeChild(textarea);
    }

    function showCopyMessage(message) {
      copyMessage.textContent = message;
      setTimeout(function() { copyMessage.textContent = ""; }, 3000);
    }

    function printQR() {
      var poster = root.querySelector("#qrp-poster-canvas");
      if (!poster) {
        errorBox.textContent = "Please generate your QR first.";
        return;
      }
      window.print();
    }

    function resetGenerator() {
      upiInput.value = "";
      nameInput.value = "";
      amountInput.value = "";
      noteInput.value = "";
      logoInput.value = "";
      currentUPILink = "";
      currentLogoData = null;
      selectedTheme = "classic";

      themeOptions.forEach(function(item) {
        item.classList.toggle("is-selected", item.getAttribute("data-theme") === "classic");
      });

      logoName.textContent = "";
      logoPreviewBox.innerHTML = '<div class="qrp-default-logo"><span>OSM</span><b>LY</b></div>';
      errorBox.textContent = "";
      copyMessage.textContent = "";

      previewArea.innerHTML = '<div class="qrp-empty"><div class="qrp-empty-icon">QR</div><h3>Your 4×6 QR design will appear here</h3><p>Enter your details, upload your logo and click <strong>Generate UPI QR</strong>.</p></div>';

      paymentInfo.style.display = "none";
      actions.style.display = "none";
      status.textContent = "Waiting for details";
      status.style.background = "#f1f5f9";
      status.style.color = "#64748b";
    }

    generateButton.addEventListener("click", generateQR);
    resetButton.addEventListener("click", resetGenerator);
    downloadButton.addEventListener("click", downloadQR);
    printButton.addEventListener("click", printQR);
    copyButton.addEventListener("click", copyUPILink);

    [upiInput, nameInput, amountInput, noteInput].forEach(function(input) {
      input.addEventListener("keydown", function(event) {
        if (event.key === "Enter") {
          event.preventDefault();
          generateQR();
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOsmlyUPI);
  } else {
    initOsmlyUPI();
  }
})();